{
  "inputTypes": {
    "AddAssignmentReportInput": {
      "date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "user_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "AddBilderitMaintenancePlanInput": {
      "base_period": {
        "kind": "scalar",
        "name": "Float"
      },
      "brand_tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "machine_parts": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "MachinePartInput"
        }
      },
      "period_type": {
        "kind": "scalar",
        "name": "PeriodType"
      },
      "programs": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "MPProgramInput"
        }
      },
      "tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "title": {
        "kind": "scalar",
        "name": "String"
      },
      "type_tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      }
    },
    "AddBusinessUnitInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "AddCertificationCopyRecipientInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "email": {
        "kind": "scalar",
        "name": "String"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "AddChecklistInput": {
      "ad_hoc_items": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "ChecklistAdHocItemInput"
        }
      },
      "answers": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "ChecklistAnswerInput"
        }
      },
      "closing_note": {
        "kind": "scalar",
        "name": "String"
      },
      "completed_at": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "completed_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "counter_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "id": {
        "kind": "scalar",
        "name": "ID"
      },
      "location": {
        "kind": "input",
        "name": "ChecklistLocationInput"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "started_at": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "template_version_id": {
        "kind": "scalar",
        "name": "ID"
      }
    },
    "AddCompanyInput": {
      "address": {
        "kind": "scalar",
        "name": "String"
      },
      "cuit": {
        "kind": "scalar",
        "name": "String"
      },
      "email": {
        "kind": "scalar",
        "name": "String"
      },
      "logo": {
        "kind": "scalar",
        "name": "String"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "phone": {
        "kind": "scalar",
        "name": "String"
      },
      "website": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "AddCompanyMachineExtraDataInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "field_name": {
        "kind": "scalar",
        "name": "String"
      },
      "field_type": {
        "kind": "scalar",
        "name": "MachineExtraDataFieldType"
      },
      "is_required": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "machine_group": {
        "kind": "scalar",
        "name": "MachineGroup"
      },
      "unit": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "AddDailyReportInput": {
      "comments": {
        "kind": "scalar",
        "name": "String"
      },
      "cost_center_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "file_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "filters": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "fuel": {
        "kind": "scalar",
        "name": "Float"
      },
      "grease": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "lat": {
        "kind": "scalar",
        "name": "Float"
      },
      "lon": {
        "kind": "scalar",
        "name": "Float"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "motor_oil": {
        "kind": "scalar",
        "name": "Float"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "tasks": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "AddDailyReportOfflineInput": {
      "comments": {
        "kind": "scalar",
        "name": "String"
      },
      "cost_center_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "files_data_url": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "String"
        }
      },
      "filters": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "fuel": {
        "kind": "scalar",
        "name": "Float"
      },
      "grease": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "lat": {
        "kind": "scalar",
        "name": "Float"
      },
      "lon": {
        "kind": "scalar",
        "name": "Float"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "motor_oil": {
        "kind": "scalar",
        "name": "Float"
      },
      "tasks": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "AddDocumentInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "expiration_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "file_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "superseded_document_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "user_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "AddFixedAssetInput": {
      "brand": {
        "kind": "scalar",
        "name": "String"
      },
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "domain": {
        "kind": "scalar",
        "name": "String"
      },
      "extra_data": {
        "kind": "scalar",
        "name": "JSONObject"
      },
      "fuel_capacity": {
        "kind": "scalar",
        "name": "Float"
      },
      "model": {
        "kind": "scalar",
        "name": "String"
      },
      "mp_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "observations": {
        "kind": "scalar",
        "name": "String"
      },
      "owner": {
        "kind": "scalar",
        "name": "String"
      },
      "ownership_type": {
        "kind": "scalar",
        "name": "OwnershipType"
      },
      "ownership_type_other": {
        "kind": "scalar",
        "name": "String"
      },
      "photo_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "replacement_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "serial_number": {
        "kind": "scalar",
        "name": "String"
      },
      "service_period": {
        "kind": "scalar",
        "name": "Float"
      },
      "service_period_type": {
        "kind": "scalar",
        "name": "PeriodType"
      },
      "subtype": {
        "kind": "scalar",
        "name": "String"
      },
      "type_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "year": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "AddFuelDispatchedReportInput": {
      "datetime": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "destination_counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "destination_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "destination_project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "file_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "flowmeter_end": {
        "kind": "scalar",
        "name": "Float"
      },
      "flowmeter_start": {
        "kind": "scalar",
        "name": "Float"
      },
      "fuel_type": {
        "kind": "scalar",
        "name": "FuelType"
      },
      "lat": {
        "kind": "scalar",
        "name": "Float"
      },
      "lon": {
        "kind": "scalar",
        "name": "Float"
      },
      "observations": {
        "kind": "scalar",
        "name": "String"
      },
      "provider_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "source_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "source_project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "verified_by": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "AddFuelProviderInput": {
      "comments": {
        "kind": "scalar",
        "name": "String"
      },
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "AddHeavyEquipmentInput": {
      "brand": {
        "kind": "scalar",
        "name": "String"
      },
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "domain": {
        "kind": "scalar",
        "name": "String"
      },
      "engine_number": {
        "kind": "scalar",
        "name": "String"
      },
      "extra_data": {
        "kind": "scalar",
        "name": "JSONObject"
      },
      "fuel_capacity": {
        "kind": "scalar",
        "name": "Float"
      },
      "model": {
        "kind": "scalar",
        "name": "String"
      },
      "mp_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "observations": {
        "kind": "scalar",
        "name": "String"
      },
      "owner": {
        "kind": "scalar",
        "name": "String"
      },
      "ownership_type": {
        "kind": "scalar",
        "name": "OwnershipType"
      },
      "ownership_type_other": {
        "kind": "scalar",
        "name": "String"
      },
      "photo_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "power": {
        "kind": "scalar",
        "name": "Float"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "replacement_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "serial_number": {
        "kind": "scalar",
        "name": "String"
      },
      "service_period": {
        "kind": "scalar",
        "name": "Float"
      },
      "service_period_type": {
        "kind": "scalar",
        "name": "PeriodType"
      },
      "subtype": {
        "kind": "scalar",
        "name": "String"
      },
      "type_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "weight": {
        "kind": "scalar",
        "name": "Float"
      },
      "year": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "AddLocationInput": {
      "lat": {
        "kind": "scalar",
        "name": "Float"
      },
      "lon": {
        "kind": "scalar",
        "name": "Float"
      }
    },
    "AddMachineConsumableInput": {
      "brand": {
        "kind": "scalar",
        "name": "String"
      },
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "equivalences": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "MachineConsumableRef"
        }
      },
      "internal_code": {
        "kind": "scalar",
        "name": "String"
      },
      "manufacturer_code": {
        "kind": "scalar",
        "name": "String"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "unit": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "AddMachineNoticeInput": {
      "counter_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "file_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "message": {
        "kind": "scalar",
        "name": "String"
      },
      "severity": {
        "kind": "scalar",
        "name": "MachineNoticeSeverity"
      },
      "suggestion_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      }
    },
    "AddMaintenancePlanInput": {
      "base_period": {
        "kind": "scalar",
        "name": "Float"
      },
      "brand_tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "machine_parts": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "MachinePartInput"
        }
      },
      "period_type": {
        "kind": "scalar",
        "name": "PeriodType"
      },
      "programs": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "MPProgramInput"
        }
      },
      "tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "title": {
        "kind": "scalar",
        "name": "String"
      },
      "type_tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      }
    },
    "AddManagedEmployeeInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "password": {
        "kind": "scalar",
        "name": "String"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "role": {
        "kind": "scalar",
        "name": "RoleNamesToInvite"
      },
      "user": {
        "kind": "input",
        "name": "NewUserInput"
      }
    },
    "AddMobilityInput": {
      "brand": {
        "kind": "scalar",
        "name": "String"
      },
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "domain": {
        "kind": "scalar",
        "name": "String"
      },
      "engine_number": {
        "kind": "scalar",
        "name": "String"
      },
      "extra_data": {
        "kind": "scalar",
        "name": "JSONObject"
      },
      "fuel_capacity": {
        "kind": "scalar",
        "name": "Float"
      },
      "fuel_type": {
        "kind": "scalar",
        "name": "FuelType"
      },
      "model": {
        "kind": "scalar",
        "name": "String"
      },
      "mp_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "observations": {
        "kind": "scalar",
        "name": "String"
      },
      "owner": {
        "kind": "scalar",
        "name": "String"
      },
      "ownership_type": {
        "kind": "scalar",
        "name": "OwnershipType"
      },
      "ownership_type_other": {
        "kind": "scalar",
        "name": "String"
      },
      "photo_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "power": {
        "kind": "scalar",
        "name": "Float"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "replacement_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "serial_number": {
        "kind": "scalar",
        "name": "String"
      },
      "service_period": {
        "kind": "scalar",
        "name": "Float"
      },
      "service_period_type": {
        "kind": "scalar",
        "name": "PeriodType"
      },
      "subtype": {
        "kind": "scalar",
        "name": "String"
      },
      "type_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "weight": {
        "kind": "scalar",
        "name": "Float"
      },
      "year": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "AddOutOfServiceReportForDateRangeInput": {
      "cause": {
        "kind": "scalar",
        "name": "String"
      },
      "charge_type": {
        "kind": "scalar",
        "name": "OOSChargeType"
      },
      "counter_type": {
        "kind": "scalar",
        "name": "CounterType"
      },
      "counter_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "end_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "start_date": {
        "kind": "scalar",
        "name": "LocalDate"
      }
    },
    "AddProjectCostCenterInput": {
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "AddProjectInput": {
      "business_unit_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "client": {
        "kind": "scalar",
        "name": "String"
      },
      "code": {
        "kind": "scalar",
        "name": "String"
      },
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "location": {
        "kind": "input",
        "name": "AddLocationInput"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "ute": {
        "kind": "input",
        "name": "AddUTEInput"
      }
    },
    "AddRoleInput": {
      "business_unit_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "email": {
        "kind": "scalar",
        "name": "String"
      },
      "id": {
        "kind": "scalar",
        "name": "Int"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "role_type": {
        "kind": "scalar",
        "name": "RoleNamesToInvite"
      }
    },
    "AddServiceReportInput": {
      "comments": {
        "kind": "scalar",
        "name": "String"
      },
      "counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "current_sequence_index": {
        "kind": "scalar",
        "name": "Int"
      },
      "date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "file_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "service_type": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "AddStockControlReportInput": {
      "datetime": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "file_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "lat": {
        "kind": "scalar",
        "name": "Float"
      },
      "lon": {
        "kind": "scalar",
        "name": "Float"
      },
      "observations": {
        "kind": "scalar",
        "name": "String"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "stock_measured": {
        "kind": "scalar",
        "name": "Float"
      },
      "tank_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "AddTagGroupInput": {
      "context": {
        "kind": "input",
        "name": "Context"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "scope": {
        "kind": "scalar",
        "name": "TagScope"
      }
    },
    "AddTagInput": {
      "color": {
        "kind": "scalar",
        "name": "TagColor"
      },
      "context": {
        "kind": "input",
        "name": "Context"
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "group_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "icon": {
        "kind": "scalar",
        "name": "String"
      },
      "scope": {
        "kind": "scalar",
        "name": "TagScope"
      },
      "tag": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "AddTruckInput": {
      "brand": {
        "kind": "scalar",
        "name": "String"
      },
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "domain": {
        "kind": "scalar",
        "name": "String"
      },
      "engine_number": {
        "kind": "scalar",
        "name": "String"
      },
      "extra_data": {
        "kind": "scalar",
        "name": "JSONObject"
      },
      "fuel_capacity": {
        "kind": "scalar",
        "name": "Float"
      },
      "model": {
        "kind": "scalar",
        "name": "String"
      },
      "mp_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "observations": {
        "kind": "scalar",
        "name": "String"
      },
      "owner": {
        "kind": "scalar",
        "name": "String"
      },
      "ownership_type": {
        "kind": "scalar",
        "name": "OwnershipType"
      },
      "ownership_type_other": {
        "kind": "scalar",
        "name": "String"
      },
      "photo_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "power": {
        "kind": "scalar",
        "name": "Float"
      },
      "preferred_counter_type": {
        "kind": "scalar",
        "name": "CounterType"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "replacement_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "serial_number": {
        "kind": "scalar",
        "name": "String"
      },
      "service_period": {
        "kind": "scalar",
        "name": "Float"
      },
      "service_period_type": {
        "kind": "scalar",
        "name": "PeriodType"
      },
      "subtype": {
        "kind": "scalar",
        "name": "String"
      },
      "type_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "weight": {
        "kind": "scalar",
        "name": "Float"
      },
      "year": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "AddUTEInput": {
      "cuit": {
        "kind": "scalar",
        "name": "String"
      },
      "partners": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "AddUTEPartnerInput"
        }
      }
    },
    "AddUTEPartnerInput": {
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "percentage": {
        "kind": "scalar",
        "name": "Float"
      }
    },
    "AddWorkOrderHoursInput": {
      "labor_type": {
        "kind": "scalar",
        "name": "String"
      },
      "notes": {
        "kind": "scalar",
        "name": "String"
      },
      "planned_hours": {
        "kind": "scalar",
        "name": "Float"
      },
      "user_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "AddWorkOrderInput": {
      "comments_draft": {
        "kind": "scalar",
        "name": "String"
      },
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "file_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "hours": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "AddWorkOrderHoursInput"
        }
      },
      "id": {
        "kind": "scalar",
        "name": "String"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "program_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "tasks": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "AddWorkOrderTaskInput"
        }
      },
      "title": {
        "kind": "scalar",
        "name": "String"
      },
      "type": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "AddWorkOrderTaskInput": {
      "action": {
        "kind": "scalar",
        "name": "String"
      },
      "compartment": {
        "kind": "scalar",
        "name": "String"
      },
      "id": {
        "kind": "scalar",
        "name": "ID"
      },
      "item": {
        "kind": "scalar",
        "name": "String"
      },
      "preferred_consumable_code": {
        "kind": "scalar",
        "name": "String"
      },
      "preferred_quantity": {
        "kind": "scalar",
        "name": "Float"
      }
    },
    "AssignMaintenancePlanBatchInput": {
      "machine_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "Int"
        }
      },
      "mp_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "AssignWorkOrderInput": {
      "user_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "Int"
        }
      },
      "work_order_id": {
        "kind": "scalar",
        "name": "ID"
      }
    },
    "BatchAddAvailableReportInput": {
      "dates": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "LocalDate"
        }
      },
      "machine_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "Int"
        }
      },
      "observation": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "CalibrateTrackerDeviceInput": {
      "ignition_voltage_threshold": {
        "kind": "scalar",
        "name": "Float"
      }
    },
    "CancelIdentityClaimForUserInput": {
      "user_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "CertificationHistoryFilter": {
      "from": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "ownership_group": {
        "kind": "scalar",
        "name": "RentalOwnershipGroup"
      },
      "status": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "RentalCertificationStatus"
        }
      },
      "to": {
        "kind": "scalar",
        "name": "LocalDate"
      }
    },
    "ChecklistAdHocItemInput": {
      "label": {
        "kind": "scalar",
        "name": "String"
      },
      "observation": {
        "kind": "scalar",
        "name": "String"
      },
      "ok": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "photos_data_url": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "String"
        }
      }
    },
    "ChecklistAnswerInput": {
      "choice_key": {
        "kind": "scalar",
        "name": "String"
      },
      "date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "kind": {
        "kind": "scalar",
        "name": "ChecklistAnswerKind"
      },
      "na_reason": {
        "kind": "scalar",
        "name": "String"
      },
      "observation": {
        "kind": "scalar",
        "name": "String"
      },
      "ok": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "photos_data_url": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "String"
        }
      },
      "template_item_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "text": {
        "kind": "scalar",
        "name": "String"
      },
      "value_number": {
        "kind": "scalar",
        "name": "Float"
      }
    },
    "ChecklistAssignmentRuleInput": {
      "machine_group": {
        "kind": "scalar",
        "name": "MachineGroup"
      },
      "scope_type": {
        "kind": "scalar",
        "name": "ChecklistAssignmentScope"
      },
      "target_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "ChecklistLocationInput": {
      "accuracy_m": {
        "kind": "scalar",
        "name": "Float"
      },
      "captured_at": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "latitude": {
        "kind": "scalar",
        "name": "Float"
      },
      "longitude": {
        "kind": "scalar",
        "name": "Float"
      }
    },
    "ChecklistTemplateItemInput": {
      "criteria": {
        "kind": "scalar",
        "name": "JSONObject"
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "fail_severity": {
        "kind": "scalar",
        "name": "MachineNoticeSeverity"
      },
      "item_key": {
        "kind": "scalar",
        "name": "ID"
      },
      "item_type": {
        "kind": "scalar",
        "name": "ChecklistItemType"
      },
      "label": {
        "kind": "scalar",
        "name": "String"
      },
      "position": {
        "kind": "scalar",
        "name": "Int"
      },
      "requirement": {
        "kind": "scalar",
        "name": "ChecklistItemRequirement"
      },
      "section": {
        "kind": "scalar",
        "name": "String"
      },
      "unit": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "ConfirmIdentityClaimInput": {
      "password": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "Context": {
      "business_unit_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "CounterInput": {
      "end": {
        "kind": "scalar",
        "name": "Float"
      },
      "start": {
        "kind": "scalar",
        "name": "Float"
      },
      "type": {
        "kind": "scalar",
        "name": "CounterType"
      }
    },
    "CounterValueInput": {
      "type": {
        "kind": "scalar",
        "name": "CounterType"
      },
      "value": {
        "kind": "scalar",
        "name": "Float"
      }
    },
    "CreateChecklistTemplateInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "title": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "CreatePublicApiClientInput": {
      "companyId": {
        "kind": "scalar",
        "name": "Int"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "owner": {
        "kind": "input",
        "name": "PublicApiContactInput"
      },
      "roles": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "PublicApiKeyRole"
        }
      },
      "technical": {
        "kind": "input",
        "name": "PublicApiContactInput"
      }
    },
    "CreateRentalParameterDefinitionInput": {
      "code": {
        "kind": "scalar",
        "name": "RentalParamsCode"
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "display_name": {
        "kind": "scalar",
        "name": "String"
      },
      "options": {
        "kind": "scalar",
        "name": "JSON"
      },
      "symbol": {
        "kind": "scalar",
        "name": "String"
      },
      "type": {
        "kind": "scalar",
        "name": "DataType"
      },
      "unit": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "Cursor": {
      "limit": {
        "kind": "scalar",
        "name": "Int"
      },
      "next": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "DisableBilderitModuleInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "module_id": {
        "kind": "scalar",
        "name": "BilderitModuleId"
      }
    },
    "DisableToCreateCompanyInput": {
      "email": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "EnableBilderitModuleInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "end_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "is_demo": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "module_id": {
        "kind": "scalar",
        "name": "BilderitModuleId"
      }
    },
    "EnableToCreateCompanyInput": {
      "email": {
        "kind": "scalar",
        "name": "String"
      },
      "end_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "is_demo": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "modules": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "BilderitModuleId"
        }
      }
    },
    "FilterChecklistTemplates": {
      "include_archived": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "query": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "FilterChecklists": {
      "created_by_me": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "from": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "has_failures": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "machine_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "Int"
        }
      },
      "project_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "Int"
        }
      },
      "query": {
        "kind": "scalar",
        "name": "String"
      },
      "template_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "to": {
        "kind": "scalar",
        "name": "LocalDate"
      }
    },
    "FilterDailyReports": {
      "end_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "group": {
        "kind": "scalar",
        "name": "MachineGroup"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "start_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "status": {
        "kind": "scalar",
        "name": "MachineReportStatus"
      }
    },
    "FilterDailyReportsByDayStats": {
      "group": {
        "kind": "scalar",
        "name": "MachineGroup"
      }
    },
    "FilterDateRange": {
      "end_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "start_date": {
        "kind": "scalar",
        "name": "LocalDate"
      }
    },
    "FilterEmployee": {
      "query": {
        "kind": "scalar",
        "name": "String"
      },
      "roles": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "RoleNames"
        }
      },
      "user_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "FilterFuelTanks": {
      "fuel_participation": {
        "kind": "scalar",
        "name": "FuelParticipation"
      },
      "id": {
        "kind": "scalar",
        "name": "Int"
      },
      "query": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "FilterMachine": {
      "fuel_participations": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "FuelParticipation"
        }
      },
      "group": {
        "kind": "scalar",
        "name": "MachineGroup"
      },
      "id": {
        "kind": "scalar",
        "name": "Int"
      },
      "is_archived": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "query": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "FilterMachineConsumables": {
      "query": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "FilterMachineHistory": {
      "end_date": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "kinds": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "MachineHistoryEventKind"
        }
      },
      "latest": {
        "kind": "scalar",
        "name": "Int"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "project_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "Int"
        }
      },
      "query": {
        "kind": "scalar",
        "name": "String"
      },
      "reporter_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "Int"
        }
      },
      "start_date": {
        "kind": "scalar",
        "name": "DateTime"
      }
    },
    "FilterMachineNoticeDashboard": {
      "end_date": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "has_linked_ot": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "mode": {
        "kind": "scalar",
        "name": "MachineNoticeDashboardMode"
      },
      "query": {
        "kind": "scalar",
        "name": "String"
      },
      "reporter_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "severity": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "MachineNoticeSeverity"
        }
      },
      "sort": {
        "kind": "scalar",
        "name": "MachineNoticeDashboardSort"
      },
      "start_date": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "status": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "MachineNoticeStatus"
        }
      },
      "tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      }
    },
    "FilterMachineNotices": {
      "end_date": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "has_linked_ot": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "query": {
        "kind": "scalar",
        "name": "String"
      },
      "reporter_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "severity": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "MachineNoticeSeverity"
        }
      },
      "start_date": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "status": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "MachineNoticeStatus"
        }
      }
    },
    "FilterMachineParts": {
      "query": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "FilterMaintenancePlans": {
      "brand": {
        "kind": "scalar",
        "name": "String"
      },
      "query": {
        "kind": "scalar",
        "name": "String"
      },
      "status": {
        "kind": "scalar",
        "name": "MaintenancePlanStatus"
      },
      "type": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "FilterMyDailyReports": {
      "end_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "start_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "status": {
        "kind": "scalar",
        "name": "MachineReportStatus"
      }
    },
    "FilterMyMachineNotices": {
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "severity": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "MachineNoticeSeverity"
        }
      },
      "status": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "MachineNoticeStatus"
        }
      }
    },
    "FilterPagination": {
      "current_page": {
        "kind": "scalar",
        "name": "Int"
      },
      "per_page": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "FilterUser": {
      "query": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "FilterWorkOrders": {
      "end_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "start_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "status": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "WorkOrderStatus"
        }
      },
      "tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "type": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "String"
        }
      }
    },
    "ForceApproveCertificationInput": {
      "certification_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "reason": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "ForceRejectCertificationInput": {
      "certification_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "reason": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "GetDocumentsFilter": {
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "scope": {
        "kind": "scalar",
        "name": "DocumentScope"
      },
      "user_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "GetFuelDispatchedReportsFilter": {
      "end_date": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "source_type": {
        "kind": "scalar",
        "name": "FuelSourceType"
      },
      "start_date": {
        "kind": "scalar",
        "name": "DateTime"
      }
    },
    "GetMachineByNameOfflineFilter": {
      "name": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "GetMachinesFuelDashboardFilter": {
      "end_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "start_date": {
        "kind": "scalar",
        "name": "LocalDate"
      }
    },
    "GetRentalByProjectInput": {
      "month": {
        "kind": "scalar",
        "name": "String"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "GetRentalParameterByScopeInput": {
      "business_unit_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "GetStockControlReportsFilter": {
      "end_date": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "start_date": {
        "kind": "scalar",
        "name": "DateTime"
      }
    },
    "GetTanksDashboardFilter": {
      "end_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "start_date": {
        "kind": "scalar",
        "name": "LocalDate"
      }
    },
    "GetTelemetryDevicesFilter": {
      "category": {
        "kind": "scalar",
        "name": "TelemetryDeviceCategory"
      }
    },
    "GetTimeSeriesByBilderitConnectDeviceIdParams": {
      "from_utc": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "to_utc": {
        "kind": "scalar",
        "name": "DateTime"
      }
    },
    "GetUploadTargetInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "content_type": {
        "kind": "scalar",
        "name": "String"
      },
      "file_name": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "ImportBilderitMaintenancePlanInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "import_consumables": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "import_consumables_options": {
        "kind": "input",
        "name": "ImportConsumablesOptionsInput"
      },
      "on_duplicate_plan": {
        "kind": "scalar",
        "name": "OnDuplicatePlan"
      },
      "plan_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "ImportConsumablesOptionsInput": {
      "on_conflict": {
        "kind": "scalar",
        "name": "OnConsumableConflict"
      },
      "with_equivalences": {
        "kind": "scalar",
        "name": "Boolean"
      }
    },
    "LinkDeviceToMachineInput": {
      "flespi_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "LinkMachineWithTMProviderInput": {
      "machineId": {
        "kind": "scalar",
        "name": "Int"
      },
      "provider": {
        "kind": "scalar",
        "name": "TMProvider"
      },
      "providerId": {
        "kind": "scalar",
        "name": "ID"
      }
    },
    "MPProgramInput": {
      "actions": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "ProgramActionInput"
        }
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "id": {
        "kind": "scalar",
        "name": "ID"
      },
      "multiplier": {
        "kind": "scalar",
        "name": "Int"
      },
      "title": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "MachineConsumableRef": {
      "id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "MachinePartInput": {
      "compartment": {
        "kind": "scalar",
        "name": "String"
      },
      "default_consumable": {
        "kind": "input",
        "name": "MachineConsumableRef"
      },
      "id": {
        "kind": "scalar",
        "name": "ID"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "MachinePartRef": {
      "id": {
        "kind": "scalar",
        "name": "ID"
      }
    },
    "MergeIdentityClaimInput": {
      "other_access_token": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "MergeTagsInput": {
      "scope": {
        "kind": "scalar",
        "name": "TagScope"
      },
      "source_tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "target_tag_id": {
        "kind": "scalar",
        "name": "ID"
      }
    },
    "MoveMachineInput": {
      "comments": {
        "kind": "scalar",
        "name": "String"
      },
      "entry_counter_type": {
        "kind": "scalar",
        "name": "CounterType"
      },
      "entry_counter_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "entry_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "exit_counter_type": {
        "kind": "scalar",
        "name": "CounterType"
      },
      "exit_counter_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "exit_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "file_ids_entry_checkin": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "file_ids_entry_checkout": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "file_ids_exit_checkin": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "file_ids_exit_checkout": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "to_project_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "MyCertificatesToReviewFilter": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "ownership_group": {
        "kind": "scalar",
        "name": "RentalOwnershipGroup"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "status": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "RentalCertificationStatus"
        }
      }
    },
    "NewUserInput": {
      "address": {
        "kind": "scalar",
        "name": "String"
      },
      "birthday": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "cuil": {
        "kind": "scalar",
        "name": "String"
      },
      "dni": {
        "kind": "scalar",
        "name": "String"
      },
      "first_name": {
        "kind": "scalar",
        "name": "String"
      },
      "gender": {
        "kind": "scalar",
        "name": "String"
      },
      "last_name": {
        "kind": "scalar",
        "name": "String"
      },
      "phone": {
        "kind": "scalar",
        "name": "String"
      },
      "username": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "OffsetPaginationInput": {
      "limit": {
        "kind": "scalar",
        "name": "Int"
      },
      "offset": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "PreviewBilderitReportInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "report_type": {
        "kind": "scalar",
        "name": "BilderitReportType"
      }
    },
    "ProgramActionInput": {
      "action": {
        "kind": "scalar",
        "name": "String"
      },
      "consumable_override": {
        "kind": "input",
        "name": "MachineConsumableRef"
      },
      "consumable_quantity": {
        "kind": "scalar",
        "name": "Float"
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "id": {
        "kind": "scalar",
        "name": "ID"
      },
      "machine_part": {
        "kind": "input",
        "name": "MachinePartRef"
      }
    },
    "PublicApiContactInput": {
      "email": {
        "kind": "scalar",
        "name": "String"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "PushTopicPreferenceInput": {
      "company_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "project_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "topic": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "RegisterPushSubscriptionInput": {
      "app": {
        "kind": "scalar",
        "name": "String"
      },
      "auth": {
        "kind": "scalar",
        "name": "String"
      },
      "deviceId": {
        "kind": "scalar",
        "name": "String"
      },
      "endpoint": {
        "kind": "scalar",
        "name": "String"
      },
      "p256dh": {
        "kind": "scalar",
        "name": "String"
      },
      "userAgent": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "RegisterWorkOrderTaskInput": {
      "task_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "used_consumable_code": {
        "kind": "scalar",
        "name": "String"
      },
      "used_quantity": {
        "kind": "scalar",
        "name": "Float"
      }
    },
    "RegisterWorkOrderTasksInput": {
      "ot_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "tasks": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "RegisterWorkOrderTaskInput"
        }
      }
    },
    "RemoveCertificationReviewerInput": {
      "certification_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "reason": {
        "kind": "scalar",
        "name": "String"
      },
      "reviewer_user_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "RentalFilters": {
      "group": {
        "kind": "scalar",
        "name": "MachineGroup"
      },
      "ownership_type": {
        "kind": "scalar",
        "name": "OwnershipType"
      }
    },
    "RequestIdentityClaimForUserInput": {
      "email": {
        "kind": "scalar",
        "name": "String"
      },
      "user_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "RequestIdentityClaimInput": {
      "email": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "RespondToMcpAuthorizationInput": {
      "approve": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "clientId": {
        "kind": "scalar",
        "name": "String"
      },
      "request": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "ReviewCertificationInput": {
      "action": {
        "kind": "scalar",
        "name": "ReviewAction"
      },
      "certification_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "comment": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "RosterColumnInput": {
      "header": {
        "kind": "scalar",
        "name": "String"
      },
      "n_filled": {
        "kind": "scalar",
        "name": "Int"
      },
      "n_rows": {
        "kind": "scalar",
        "name": "Int"
      },
      "samples": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "String"
        }
      },
      "sheet": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "RosterRowInput": {
      "row_index": {
        "kind": "scalar",
        "name": "Int"
      },
      "values": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "RosterRowValueInput"
        }
      }
    },
    "RosterRowValueInput": {
      "template_column": {
        "kind": "scalar",
        "name": "String"
      },
      "value": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "SaveChecklistTemplateDraftInput": {
      "counter_requirement": {
        "kind": "scalar",
        "name": "ChecklistCounterRequirement"
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "items": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "ChecklistTemplateItemInput"
        }
      },
      "template_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "title": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "SetChecklistTemplateAssignmentsInput": {
      "rules": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "ChecklistAssignmentRuleInput"
        }
      },
      "template_id": {
        "kind": "scalar",
        "name": "ID"
      }
    },
    "SetMachineFuelCapacityInput": {
      "fuel_capacity": {
        "kind": "scalar",
        "name": "Float"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "SetManagedEmployeePasswordInput": {
      "password": {
        "kind": "scalar",
        "name": "String"
      },
      "user_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "SetRentalParameterValueInput": {
      "applies_to_counter_type": {
        "kind": "scalar",
        "name": "CounterType"
      },
      "applies_to_group": {
        "kind": "scalar",
        "name": "MachineGroup"
      },
      "applies_to_type_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "owner_company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "parameter_def_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "scope_business_unit_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "scope_company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "scope_project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "target_machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "value": {
        "kind": "scalar",
        "name": "JSON"
      }
    },
    "SetWorkOrderStatusInProgressInput": {
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "user_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "Int"
        }
      }
    },
    "SetWorkOrderStatusToReviewInput": {
      "counter": {
        "kind": "input",
        "name": "CounterInput"
      }
    },
    "SubmitCertificationForReviewInput": {
      "certification_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "comment": {
        "kind": "scalar",
        "name": "String"
      },
      "external_reviewer_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "Int"
        }
      },
      "force": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "internal_reviewer_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "Int"
        }
      }
    },
    "SubscribeToBilderitReportInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "email": {
        "kind": "scalar",
        "name": "String"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "report_type": {
        "kind": "scalar",
        "name": "BilderitReportType"
      }
    },
    "SyncMachineCountersInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "SyncMachinesStatusInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "UnarchiveMachineInput": {
      "counter_type": {
        "kind": "scalar",
        "name": "CounterType"
      },
      "counter_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "UnregisterWorkOrderTasksInput": {
      "ot_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "task_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      }
    },
    "UpdateBusinessUnitInput": {
      "name": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "UpdateCompanyInput": {
      "address": {
        "kind": "scalar",
        "name": "String"
      },
      "cuit": {
        "kind": "scalar",
        "name": "String"
      },
      "email": {
        "kind": "scalar",
        "name": "String"
      },
      "logo": {
        "kind": "scalar",
        "name": "String"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "phone": {
        "kind": "scalar",
        "name": "String"
      },
      "website": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "UpdateDailyReportInput": {
      "comments": {
        "kind": "scalar",
        "name": "String"
      },
      "cost_center_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "file_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "filters": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "fuel": {
        "kind": "scalar",
        "name": "Float"
      },
      "grease": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "lat": {
        "kind": "scalar",
        "name": "Float"
      },
      "lon": {
        "kind": "scalar",
        "name": "Float"
      },
      "motor_oil": {
        "kind": "scalar",
        "name": "Float"
      },
      "tasks": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "UpdateDocumentInput": {
      "document_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "expiration_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "UpdateDocumentTagsInput": {
      "document_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      }
    },
    "UpdateFederatedIdentityInformationInput": {
      "address": {
        "kind": "scalar",
        "name": "String"
      },
      "birthday": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "cuil": {
        "kind": "scalar",
        "name": "String"
      },
      "dni": {
        "kind": "scalar",
        "name": "String"
      },
      "first_name": {
        "kind": "scalar",
        "name": "String"
      },
      "gender": {
        "kind": "scalar",
        "name": "String"
      },
      "last_name": {
        "kind": "scalar",
        "name": "String"
      },
      "phone": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "UpdateFixedAssetInput": {
      "brand": {
        "kind": "scalar",
        "name": "String"
      },
      "counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "domain": {
        "kind": "scalar",
        "name": "String"
      },
      "extra_data": {
        "kind": "scalar",
        "name": "JSONObject"
      },
      "fuel_capacity": {
        "kind": "scalar",
        "name": "Float"
      },
      "model": {
        "kind": "scalar",
        "name": "String"
      },
      "mp_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "observations": {
        "kind": "scalar",
        "name": "String"
      },
      "owner": {
        "kind": "scalar",
        "name": "String"
      },
      "ownership_type": {
        "kind": "scalar",
        "name": "OwnershipType"
      },
      "ownership_type_other": {
        "kind": "scalar",
        "name": "String"
      },
      "photo_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "replacement_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "serial_number": {
        "kind": "scalar",
        "name": "String"
      },
      "service_period": {
        "kind": "scalar",
        "name": "Float"
      },
      "service_period_type": {
        "kind": "scalar",
        "name": "PeriodType"
      },
      "subtype": {
        "kind": "scalar",
        "name": "String"
      },
      "type_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "year": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "UpdateFuelDispatchedReportInput": {
      "destination_counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "file_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "flowmeter_end": {
        "kind": "scalar",
        "name": "Float"
      },
      "flowmeter_start": {
        "kind": "scalar",
        "name": "Float"
      },
      "fuel_type": {
        "kind": "scalar",
        "name": "FuelType"
      },
      "lat": {
        "kind": "scalar",
        "name": "Float"
      },
      "lon": {
        "kind": "scalar",
        "name": "Float"
      },
      "observations": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "UpdateFuelProviderInput": {
      "comments": {
        "kind": "scalar",
        "name": "String"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "UpdateHeavyEquipmentInput": {
      "brand": {
        "kind": "scalar",
        "name": "String"
      },
      "counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "domain": {
        "kind": "scalar",
        "name": "String"
      },
      "engine_number": {
        "kind": "scalar",
        "name": "String"
      },
      "extra_data": {
        "kind": "scalar",
        "name": "JSONObject"
      },
      "fuel_capacity": {
        "kind": "scalar",
        "name": "Float"
      },
      "model": {
        "kind": "scalar",
        "name": "String"
      },
      "mp_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "observations": {
        "kind": "scalar",
        "name": "String"
      },
      "owner": {
        "kind": "scalar",
        "name": "String"
      },
      "ownership_type": {
        "kind": "scalar",
        "name": "OwnershipType"
      },
      "ownership_type_other": {
        "kind": "scalar",
        "name": "String"
      },
      "photo_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "power": {
        "kind": "scalar",
        "name": "Float"
      },
      "replacement_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "serial_number": {
        "kind": "scalar",
        "name": "String"
      },
      "service_period": {
        "kind": "scalar",
        "name": "Float"
      },
      "service_period_type": {
        "kind": "scalar",
        "name": "PeriodType"
      },
      "subtype": {
        "kind": "scalar",
        "name": "String"
      },
      "type_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "weight": {
        "kind": "scalar",
        "name": "Float"
      },
      "year": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "UpdateLocationInput": {
      "lat": {
        "kind": "scalar",
        "name": "Float"
      },
      "lon": {
        "kind": "scalar",
        "name": "Float"
      }
    },
    "UpdateMachineConsumableInput": {
      "brand": {
        "kind": "scalar",
        "name": "String"
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "equivalences": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "MachineConsumableRef"
        }
      },
      "internal_code": {
        "kind": "scalar",
        "name": "String"
      },
      "manufacturer_code": {
        "kind": "scalar",
        "name": "String"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "unit": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "UpdateMachineNoticeInput": {
      "tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      }
    },
    "UpdateMachineNoticeStatusInput": {
      "evidence_file_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "resolution_note": {
        "kind": "scalar",
        "name": "String"
      },
      "status": {
        "kind": "scalar",
        "name": "MachineNoticeStatus"
      }
    },
    "UpdateMaintenancePlanInput": {
      "base_period": {
        "kind": "scalar",
        "name": "Float"
      },
      "brand_tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "machine_parts": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "MachinePartInput"
        }
      },
      "period_type": {
        "kind": "scalar",
        "name": "PeriodType"
      },
      "programs": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "MPProgramInput"
        }
      },
      "tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "title": {
        "kind": "scalar",
        "name": "String"
      },
      "type_tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      }
    },
    "UpdateMaintenancePlanTagsInput": {
      "brand_tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "plan_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "type_tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      }
    },
    "UpdateMeInput": {
      "address": {
        "kind": "scalar",
        "name": "String"
      },
      "birthday": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "cuil": {
        "kind": "scalar",
        "name": "String"
      },
      "first_name": {
        "kind": "scalar",
        "name": "String"
      },
      "gender": {
        "kind": "scalar",
        "name": "String"
      },
      "last_name": {
        "kind": "scalar",
        "name": "String"
      },
      "phone": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "UpdateMobilityInput": {
      "brand": {
        "kind": "scalar",
        "name": "String"
      },
      "counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "domain": {
        "kind": "scalar",
        "name": "String"
      },
      "engine_number": {
        "kind": "scalar",
        "name": "String"
      },
      "extra_data": {
        "kind": "scalar",
        "name": "JSONObject"
      },
      "fuel_capacity": {
        "kind": "scalar",
        "name": "Float"
      },
      "fuel_type": {
        "kind": "scalar",
        "name": "FuelType"
      },
      "model": {
        "kind": "scalar",
        "name": "String"
      },
      "mp_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "observations": {
        "kind": "scalar",
        "name": "String"
      },
      "owner": {
        "kind": "scalar",
        "name": "String"
      },
      "ownership_type": {
        "kind": "scalar",
        "name": "OwnershipType"
      },
      "ownership_type_other": {
        "kind": "scalar",
        "name": "String"
      },
      "photo_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "power": {
        "kind": "scalar",
        "name": "Float"
      },
      "replacement_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "serial_number": {
        "kind": "scalar",
        "name": "String"
      },
      "service_period": {
        "kind": "scalar",
        "name": "Float"
      },
      "service_period_type": {
        "kind": "scalar",
        "name": "PeriodType"
      },
      "subtype": {
        "kind": "scalar",
        "name": "String"
      },
      "type_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "weight": {
        "kind": "scalar",
        "name": "Float"
      },
      "year": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "UpdateMoveReportInput": {
      "counter": {
        "kind": "input",
        "name": "CounterValueInput"
      },
      "file_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      }
    },
    "UpdateNextServiceInput": {
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "next_sequence_index": {
        "kind": "scalar",
        "name": "Int"
      },
      "service_shift": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "UpdateOOSReportInput": {
      "cause": {
        "kind": "scalar",
        "name": "String"
      },
      "charge_type": {
        "kind": "scalar",
        "name": "OOSChargeType"
      },
      "counter_type": {
        "kind": "scalar",
        "name": "CounterType"
      },
      "counter_value": {
        "kind": "scalar",
        "name": "Float"
      }
    },
    "UpdateOtHourInput": {
      "executed_hours": {
        "kind": "scalar",
        "name": "Float"
      },
      "execution_date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "id": {
        "kind": "scalar",
        "name": "ID"
      },
      "labor_type": {
        "kind": "scalar",
        "name": "String"
      },
      "notes": {
        "kind": "scalar",
        "name": "String"
      },
      "planned_hours": {
        "kind": "scalar",
        "name": "Float"
      },
      "user_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "UpdateProjectCostCenterInput": {
      "name": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "UpdateProjectInput": {
      "business_unit_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "client": {
        "kind": "scalar",
        "name": "String"
      },
      "code": {
        "kind": "scalar",
        "name": "String"
      },
      "location": {
        "kind": "input",
        "name": "UpdateLocationInput"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "ute": {
        "kind": "input",
        "name": "UpdateUTEInput"
      }
    },
    "UpdatePublicApiClientInput": {
      "comment": {
        "kind": "scalar",
        "name": "String"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "owner": {
        "kind": "input",
        "name": "PublicApiContactInput"
      },
      "roles": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "PublicApiKeyRole"
        }
      },
      "technical": {
        "kind": "input",
        "name": "PublicApiContactInput"
      }
    },
    "UpdateRentalParameterDefinitionInput": {
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "display_name": {
        "kind": "scalar",
        "name": "String"
      },
      "options": {
        "kind": "scalar",
        "name": "JSON"
      },
      "symbol": {
        "kind": "scalar",
        "name": "String"
      },
      "type": {
        "kind": "scalar",
        "name": "DataType"
      },
      "unit": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "UpdateStockControlReportInput": {
      "file_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "lat": {
        "kind": "scalar",
        "name": "Float"
      },
      "lon": {
        "kind": "scalar",
        "name": "Float"
      },
      "observations": {
        "kind": "scalar",
        "name": "String"
      },
      "stock_measured": {
        "kind": "scalar",
        "name": "Float"
      }
    },
    "UpdateTagGroupInput": {
      "id": {
        "kind": "scalar",
        "name": "ID"
      },
      "is_archived": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "scope": {
        "kind": "scalar",
        "name": "TagScope"
      }
    },
    "UpdateTagInput": {
      "color": {
        "kind": "scalar",
        "name": "TagColor"
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "group_id": {
        "kind": "scalar",
        "name": "ID"
      },
      "icon": {
        "kind": "scalar",
        "name": "String"
      },
      "id": {
        "kind": "scalar",
        "name": "ID"
      },
      "is_archived": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "scope": {
        "kind": "scalar",
        "name": "TagScope"
      },
      "tag": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "UpdateTelemetryDeviceLinkInput": {
      "counter_offset": {
        "kind": "scalar",
        "name": "Float"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "UpdateTruckInput": {
      "brand": {
        "kind": "scalar",
        "name": "String"
      },
      "counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "domain": {
        "kind": "scalar",
        "name": "String"
      },
      "engine_number": {
        "kind": "scalar",
        "name": "String"
      },
      "extra_data": {
        "kind": "scalar",
        "name": "JSONObject"
      },
      "fuel_capacity": {
        "kind": "scalar",
        "name": "Float"
      },
      "model": {
        "kind": "scalar",
        "name": "String"
      },
      "mp_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "observations": {
        "kind": "scalar",
        "name": "String"
      },
      "owner": {
        "kind": "scalar",
        "name": "String"
      },
      "ownership_type": {
        "kind": "scalar",
        "name": "OwnershipType"
      },
      "ownership_type_other": {
        "kind": "scalar",
        "name": "String"
      },
      "photo_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "power": {
        "kind": "scalar",
        "name": "Float"
      },
      "preferred_counter_type": {
        "kind": "scalar",
        "name": "CounterType"
      },
      "replacement_value": {
        "kind": "scalar",
        "name": "Float"
      },
      "serial_number": {
        "kind": "scalar",
        "name": "String"
      },
      "service_period": {
        "kind": "scalar",
        "name": "Float"
      },
      "service_period_type": {
        "kind": "scalar",
        "name": "PeriodType"
      },
      "subtype": {
        "kind": "scalar",
        "name": "String"
      },
      "type_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "weight": {
        "kind": "scalar",
        "name": "Float"
      },
      "year": {
        "kind": "scalar",
        "name": "Int"
      }
    },
    "UpdateUTEInput": {
      "cuit": {
        "kind": "scalar",
        "name": "String"
      },
      "partners": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "UpdateUTEPartnerInput"
        }
      }
    },
    "UpdateUTEPartnerInput": {
      "name": {
        "kind": "scalar",
        "name": "String"
      },
      "percentage": {
        "kind": "scalar",
        "name": "Float"
      }
    },
    "UpdateWorkOrderInput": {
      "closed_end_date": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "closed_start_date": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "comments_draft": {
        "kind": "scalar",
        "name": "String"
      },
      "comments_in_progress": {
        "kind": "scalar",
        "name": "String"
      },
      "comments_to_approve": {
        "kind": "scalar",
        "name": "String"
      },
      "comments_to_review": {
        "kind": "scalar",
        "name": "String"
      },
      "counter": {
        "kind": "input",
        "name": "CounterInput"
      },
      "description": {
        "kind": "scalar",
        "name": "String"
      },
      "draft_end_date": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "draft_start_date": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "file_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "hours": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "UpdateOtHourInput"
        }
      },
      "in_progress_end_date": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "in_progress_start_date": {
        "kind": "scalar",
        "name": "DateTime"
      },
      "machine_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "project_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "tasks": {
        "kind": "list",
        "ofType": {
          "kind": "input",
          "name": "UpdateWorkOrderTaskInput"
        }
      },
      "title": {
        "kind": "scalar",
        "name": "String"
      },
      "type": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "UpdateWorkOrderTagsInput": {
      "tag_ids": {
        "kind": "list",
        "ofType": {
          "kind": "scalar",
          "name": "ID"
        }
      },
      "work_order_id": {
        "kind": "scalar",
        "name": "ID"
      }
    },
    "UpdateWorkOrderTaskInput": {
      "action": {
        "kind": "scalar",
        "name": "String"
      },
      "compartment": {
        "kind": "scalar",
        "name": "String"
      },
      "done": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "id": {
        "kind": "scalar",
        "name": "ID"
      },
      "item": {
        "kind": "scalar",
        "name": "String"
      },
      "preferred_consumable_code": {
        "kind": "scalar",
        "name": "String"
      },
      "preferred_quantity": {
        "kind": "scalar",
        "name": "Float"
      },
      "used_consumable_code": {
        "kind": "scalar",
        "name": "String"
      },
      "used_quantity": {
        "kind": "scalar",
        "name": "Float"
      }
    },
    "UpsertCompanyIntegrationInput": {
      "company_id": {
        "kind": "scalar",
        "name": "Int"
      },
      "credentials": {
        "kind": "scalar",
        "name": "JSON"
      },
      "is_active": {
        "kind": "scalar",
        "name": "Boolean"
      },
      "provider": {
        "kind": "scalar",
        "name": "String"
      }
    },
    "VisionLinkReportsByDateInput": {
      "date": {
        "kind": "scalar",
        "name": "LocalDate"
      },
      "integration_id": {
        "kind": "scalar",
        "name": "ID"
      }
    },
    "WorkOrderTypeRef": {
      "id": {
        "kind": "scalar",
        "name": "ID"
      }
    }
  }
}